import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective,  GridDataResult } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { IDocumentListInputModel } from 'src/app/ViewModel/DocumentModel';
import { process } from '@progress/kendo-data-query';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-view-grid',
  templateUrl: './document-view-grid.component.html',
  styleUrls: ['./document-view-grid.component.css']
})
export class DocumentViewGridComponent implements OnInit {
  public documents !:any[];
  public docType !:string; 
  public projectId!:number;
  public groupId !:number;
  public gridView : any[] =[];
  public FilterDataList: any[]=[];
  public mySelection: number[] = [];
  public items!: any[] ;
  public gridViewData !: GridDataResult;
  public memberId !: number;
  public skip :number = 0;
  public selectionAction : any[]=[];

  @ViewChild(DataBindingDirective) directive:any;
  @ViewChild('docgrid') docGrid: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocumentViewGridComponent>,
    private _docService: DocumentService,
    private _scheduleDocService: ScheduleDocumentService,
    private commonService: CommonService
  ) { }

  ngOnInit() {   
    this.docType = "Repository";
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getDocumentList();   
  }

  onDocTypeChange(event:any){
    this.docType = event;
    this.getDocumentList();
  }

  
  async getDocumentList() {      
    if(this.gridView.length > 0){
     this.directive.skip = 0;
    //Reset the selection while tab changes
      this.docGrid.selectionDirective.selectedKeys = [];
    //Reset the isselected flag as false
      this.gridView.forEach(x => x.isSelected = false);
    //Reset the skip count
       this.skip = 0;
       if(this.selectionAction.length > 0){
         this.selectionAction.forEach(x=> x.isSelected = true);
       }
   }
    if (this.docType == 'Repository') {   
        let inputModel: IDocumentListInputModel = {
          projectId: this.projectId,
          groupId: this.groupId,
          memberId: this.memberId,
          transType: 'MyDocuments',
          createdFromDays: 0,
          isExcludeTransmittalDocuments: true
        }
        this.documents = await this._docService.getDocumentList(inputModel).toPromise();
      this.documents = this.documents.map((x,index) => {
        return {
          itemIndex : index,
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          authorisedByName: x.authorisedByName,
          createdByName: x.createdBy
        }
      });    
      if(!!this.data.data){
        let documentList = this.documents.filter(data => {
          let result:boolean = true;
          for(let eleIndex=0;eleIndex<this.data.data.length;eleIndex++){
            let element:any = this.data.data[eleIndex];
            if (data.docId == element.doc_Id && data.revision == element.revision_No) {
              result = false;
              break /*Once record match occured, break the inner loop*/
            }
          }
          return result;
        });
         this.gridView = documentList;       
       }else{
         this.gridView = this.documents;
       }
       this.FilterDataList = this.gridView ;
     }
    else {
      this.documents = await this._scheduleDocService.GetWorkflowPendingDocuments({ project_Id: this.projectId, group_Id: this.groupId, isExcludeTransmittalDocuments:true }).toPromise();
      this.documents = this.documents.map((x,index) => {
        return {
          itemIndex : index,
          docId: x.doc_Id,
          documentNo: x.doc_No,
          title: x.doc_Title,
          revision: x.revision_No,
          authorisedByName: x.authorized_By,
          createdByName: x.created_By
        }
      });    
      if(!!this.data.data){
        let documentList = this.documents.filter(data => {
          let result:boolean = true;
          for(let eleIndex=0;eleIndex<this.data.data.length;eleIndex++){
            let element:any = this.data.data[eleIndex];
            if (data.docId == element.doc_Id && data.revision == element.revision_No) {
              result = false;
              break /*Once record match occured, break the inner loop*/
            }
          }
          return result;
        });
         this.gridView = documentList;
       }else{
         this.gridView = this.documents;
       }
       this.FilterDataList = this.gridView ;
    } 
  }
 




public onFilterRD(inputValue: string): void {
  this.gridView = process(this.FilterDataList, {
    filter: {
      logic: "or",
      filters: [
        {
          field: 'documentNo',
          operator: 'contains',
          value: inputValue
        },
        {
          field: 'title',
          operator: 'contains',
          value: inputValue
        },
        {
          field: 'revision',
          operator: 'contains',
          value: inputValue
        },
        {
          field: 'createdByName',
          operator: 'contains',
          value: inputValue
        },
        {
          field: 'authorisedByName',
          operator: 'contains',
          value: inputValue
        },
      ],
    }
  }).data;
  this.directive.skip = 0;
}

onSelectionChange(event: any): void {     
    if (event['selectedRows'].length > 0) {   
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {        
       element.dataItem.isSelected = true;
       this.selectionAction.push(element.dataItem);     
     });
  }
  if (event['deselectedRows'].length > 0) {
    event['deselectedRows'].forEach((element: { dataItem: { docId: any; revision: any; }; }) => {
        for(let i=0;i<this.selectionAction.length;i++){
          if (element.dataItem.docId == this.selectionAction[i].docId && element.dataItem.revision == this.selectionAction[i].revision){
            this.selectionAction.splice(i,1);
          }
        }
  });
 }
}

closeDialog() { 
  this.dialogRef.close(this.selectionAction);
}

postData() {
  this.closeDialog();
}


}